<div class="account-info-container">
    <!-- Status Section -->
    <div class="status-section">
        <div class="user-status">
            <div class="user-count-badge">
                <span class="user-count">{{ client.aktiveBenutzer || 0 }}</span>
            </div>
            <mat-icon class="subscription-icon" [class.active]="client.booked && client.bookingActiv" [class.inactive]="client.booked && !client.bookingActiv" *ngIf="client.booked">subscriptions</mat-icon>
        </div>
    </div>

    <!-- Contact Actions -->
    <div class="action-group contact-actions">
        <button
            mat-icon-button
            class="action-button phone-button"
            [disabled]="!client.tel"
            (click)="firebaseService.startCall(client.tel)"
            matTooltip="Festnetz anrufen"
        >
            <mat-icon>phone</mat-icon>
        </button>
        <button
            mat-icon-button
            class="action-button phone-button"
            [disabled]="!client.mobil"
            (click)="firebaseService.startCall(client.mobil)"
            matTooltip="Mobil anrufen"
        >
            <mat-icon>phone_iphone</mat-icon>
        </button>
    </div>
    
    <!-- Client Actions -->
    <div class="action-group client-actions" *ngIf="isClient">
        <button
            mat-icon-button
            class="action-button"
            matTooltip="Benutzer als kostenfrei setzen"
            (click)="setUserFree()"
        >
            <mat-icon>money_off</mat-icon>
        </button>
        <button 
            mat-icon-button 
            class="action-button"
            [disabled]="client.aktiveBenutzer === 1"
            matTooltip="Benutzer verwalten"
        >
            <mat-icon>groups</mat-icon>
        </button>
        <button 
            mat-icon-button 
            class="action-button danger-button"
            matTooltip="MFA zurücksetzen" 
            (click)="resetMfa()"
        >
            <mat-icon>lock_reset</mat-icon>
        </button>
        <button
            mat-icon-button
            class="action-button support-button"
            matTooltip="Login mit Supportaccount"
            [disabled]="!supportId"
            (click)="loginAsAccount($event, supportId)"
        >
            <mat-icon>support_agent</mat-icon>
        </button>
        <button
            mat-icon-button
            class="action-button"
            matTooltip="Login als dieser Benutzer"
            (click)="loginAsAccount($event)"
        >
            <mat-icon>launch</mat-icon>
        </button>
    </div>
</div>
